import { render, staticRenderFns } from "./Historiques.vue?vue&type=template&id=2bf3f173&"
import script from "./Historiques.vue?vue&type=script&lang=js&"
export * from "./Historiques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports